import React from 'react';
import { ArrowRight, Star } from 'lucide-react';

const watches = [
    {
        id: 1,
        name: 'Royal Oak Offshore',
        brand: 'Audemars Piguet',
        price: '$45,000',
        image: 'https://s.alicdn.com/@sc04/kf/H035e0f1ad88a47a0a0ac77d56ab96490U/2023-New-POEDAGAR-615-Luxury-Men-Watches-Business-Top-Brand-Man-Wristwatch-Waterproof-Luminous-Date-Week-Quartz-Men-s-Watch.jpg',
        tag: 'Best Seller'
    },
    {
        id: 2,
        name: 'Nautilus 5711',
        brand: 'Patek Philippe',
        price: '$120,000',
        image: 'https://www.jiomart.com/images/product/original/rvfwo2tryq/iloz-luxury-new-amazing-look-black-professional-premium-quality-silicon-belt-analog-best-watch-for-men-product-images-rvfwo2tryq-0-202311211944.jpg?im=Resize=(500,630)',
        tag: 'Limited'
    },
    {
        id: 3,
        name: 'Submariner Date',
        brand: 'Rolex',
        price: '$14,500',
        image: 'https://images.unsplash.com/photo-1526045431048-f857369baa09?q=80&w=2070&auto=format&fit=crop',
        tag: 'Classic'
    },
];

const FeaturedCollection = () => {
    return (
        <section id="collections" className="section-padding bg-luxury-blue relative">
            {/* Decorative Background */}
            <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-luxury-cream to-transparent pointer-events-none" />

            <div className="container mx-auto relative z-10">
                <div className="flex justify-between items-end mb-16">
                    <div>
                        <h3 className="text-luxury-gold uppercase tracking-widest mb-2">Exquisite Selection</h3>
                        <h2 className="text-4xl md:text-5xl font-serif font-bold text-luxury-black">Featured Timepieces</h2>
                    </div>
                    <button className="hidden md:flex items-center gap-2 text-luxury-black hover:text-luxury-gold transition-colors group">
                        View All Collections
                        <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                    </button>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {watches.map((watch) => (
                        <div key={watch.id} className="group relative">
                            <div className="glass-card rounded-xl overflow-hidden h-[500px] relative">
                                {/* Image */}
                                <img
                                    src={watch.image}
                                    alt={watch.name}
                                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                                />

                                {/* Overlay Gradient */}
                                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent opacity-80 group-hover:opacity-90 transition-opacity" />

                                {/* Content */}
                                <div className="absolute bottom-0 left-0 w-full p-8 translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                                    <div className="flex justify-between items-start mb-2">
                                        <div>
                                            <p className="text-luxury-gold text-sm uppercase tracking-wider mb-1">{watch.brand}</p>
                                            <h3 className="text-2xl font-serif font-bold mb-2">{watch.name}</h3>
                                        </div>
                                        <div className="glass px-3 py-1 rounded-full flex items-center gap-1">
                                            <Star className="w-3 h-3 text-luxury-gold fill-luxury-gold" />
                                            <span className="text-xs">{watch.tag}</span>
                                        </div>
                                    </div>

                                    <div className="flex justify-between items-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 delay-100">
                                        <span className="text-xl font-semibold">{watch.price}</span>
                                        <button className="text-sm border-b border-luxury-gold pb-1 hover:text-luxury-gold transition-colors">
                                            View Details
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="mt-12 text-center md:hidden">
                    <button className="btn-outline w-full">
                        View All Collections
                    </button>
                </div>
            </div>
        </section>
    );
};

export default FeaturedCollection;
